import { useNavigate } from "react-router-dom";

type FormData = { uuid: { value: string } };

function Home() {
	const navigate = useNavigate();

	function handleOnSubmitContinueApplication(
		event: React.FormEvent<HTMLFormElement> & { elements: FormData }
	) {
		event.preventDefault();
		const { uuid } = event.target.elements;
		navigate(`/${uuid.value}`);
		//window.location.href = `/${uuid.value}`;
	}

	return (
		<div className="step-page" id="home">
			<section>
				<div className="container container-home">
					<div className="box">
						<h4>Ingresar nueva solicitud</h4>
						<button type="button" onClick={() => navigate("/new")}>
							Ingresar
						</button>
					</div>

					<div className="box">
						<h4>Continuar con solicitud</h4>
						<form onSubmit={handleOnSubmitContinueApplication}>
							<label htmlFor="uuid">
								<p>Código de solicitud</p>
								<input type="text" name="uuid" id="uuid" required />
							</label>

							<button type="submit">Continuar</button>
						</form>
					</div>
				</div>
			</section>
		</div>
	);
}

export { Home };
